import React from "react";

const Footer = () => {
  return <footer className="footer">&copy; 2022 by Book Club</footer>;
};

export default Footer;
